import { render } from "./WhatsappBusinessServiceParameter.vue?vue&type=template&id=ac6ae40a&scoped=true"
import script from "./WhatsappBusinessServiceParameter.vue?vue&type=script&lang=ts"
export * from "./WhatsappBusinessServiceParameter.vue?vue&type=script&lang=ts"

import "./WhatsappBusinessServiceParameter.vue?vue&type=style&index=0&id=ac6ae40a&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-ac6ae40a"

export default script